import React from 'react';

/**
 * FlipValue Logo Components - Using master PNG everywhere for consistency
 * Bright green square with black outline lightning bolt
 */

// Official FlipValue logo URL
const FLIPVALUE_LOGO_URL = 'https://i.imgur.com/hF0H8BY.png';

// Logo box for header - Uses the PNG image for perfect consistency
export function FlipValueLogoBox({ size = 'md' }) {
  const sizes = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12',
    xl: 'w-14 h-14'
  };

  return (
    <img 
      src={FLIPVALUE_LOGO_URL}
      alt="FlipValue" 
      className={`${sizes[size] || sizes.md}`}
    />
  );
}

// Full logo with text
export function FlipValueLogo({ showText = true, size = 'md' }) {
  return (
    <div className="flex items-center gap-2">
      <FlipValueLogoBox size={size} />
      {showText && (
        <span className="font-bold text-lg tracking-tight">FlipValue</span>
      )}
    </div>
  );
}

// Icon only version
export function FlipValueIcon({ className = "w-8 h-8" }) {
  return (
    <img 
      src={FLIPVALUE_LOGO_URL}
      alt="FlipValue" 
      className={className}
    />
  );
}

export default FlipValueLogo;
